import React, { useState, useEffect } from "react";
import "react-day-picker/dist/style.css";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import { useAlert } from "../../contexts/AlertContext";
import { useAtom } from "jotai";
import { authAtom } from "../../states/auth";
import Offcanvas from "react-bootstrap/Offcanvas";
import Collapse from "react-bootstrap/Collapse";
import Modal from "react-bootstrap/Modal";
import { CubeIcon, EditIcon } from "../../components/SVGIcon";
import { UsersFillIcon } from "../../components/Sidebar/SidebarIcons";
import { getExpertScheduleUsers } from "../../services/userService";
import { getExpertiseByAdmin } from "../../services/expertiseService";
import Form from "react-bootstrap/Form";
import {
  createInternalChatRequest,
  createSupportChatRequest,
} from "../../services/supportService";
import ImagePreviewLightbox from "../../components/ImagePreviewLightbox";
import { getCompanyStatus } from "../CompanyStatus";

function formatTime(date) {
  return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

function convertToLocal(utcTime) {
  if (utcTime) {
    const [h, m, s] = utcTime?.split(":");
    const utcDate = new Date(Date.UTC(1970, 0, 1, h, m, s));
    return formatTime(
      new Date(
        utcDate.toLocaleString("en-US", {
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        }),
      ),
    );
  }
}

const getAddress = (userInfo) => {
  const addressArr = [];
  if (userInfo?.address) {
    addressArr.push(userInfo?.address);
  }
  if (userInfo?.city) {
    addressArr.push(userInfo?.city);
  }
  if (userInfo?.state?.name) {
    addressArr.push(userInfo?.state?.name);
  }
  if (userInfo?.country?.code) {
    addressArr.push(userInfo?.country?.code);
  }
  if (userInfo?.zipCode) {
    addressArr.push(userInfo?.zipCode);
  }
  return addressArr.join(", ");
};

const StartNewConversation = ({
  newChatSidebar,
  inboxConversations,
  setConversationId,
  setNewChatSidebar,
  getCalenderList,
}) => {
  // const [newChatSidebar, setNewChatSidebar] = useState(false);
  const [createGroup, setCreateGroup] = useState(false);
  const [createCompany, setCreateCompany] = useState(false);
  const [showCompany, setShowCompany] = useState(null);
  const [tab, setTab] = useState(1);
  const [companyExpertise, setCompanyExpertise] = useState(null);
  const [callRequest, setCallRequest] = useState({
    adminId: null,
    expertiseId: null,
    participantId: null,
    startTime: null,
    endTime: null,
  });
  const [companyDetailsCollapse, setCompanyDetailsCollapse] = useState(false);
  const [productCollapse, setProductCollapse] = useState({});
  const { showAlert } = useAlert();
  const [modalShow, setModalShow] = useState(false);
  const [requestDate, setRequestDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [supportList, setSupportList] = useState(false);
  const [filter, setFilter] = useState({
    no_of_result: 20,
    page: 1,
    search: "",
    userTypeFilter: 0,
  });

  const [companyExpertiseFilter, setCompanyExpertiseFilter] = useState({
    no_of_result: 20,
    page: 1,
    search: "",
  });

  const resetSidebar = () => {
    setTab(1);
    setShowCompany(null);
    setNewChatSidebar(false);
    setCallRequest({
      adminId: null,
      expertiseId: null,
      participantId: null,
      startTime: null,
      endTime: null,
    });
  };
  const groupByFirstCharacter = (userList) => {
    if (!userList) return {};
    console.log("userList", userList);
    // 1. Sort the list alphabetically first
    const sortedList = [...userList].sort((a, b) => {
      const nameA = a.fullName ? a.fullName.toLowerCase() : "";
      const nameB = b.fullName ? b.fullName.toLowerCase() : "";
      return nameA.localeCompare(nameB);
    });

    // 2. Group them by first letter
    return sortedList.reduce((acc, user) => {
      const firstChar = user.fullName
        ? user.fullName.charAt(0).toUpperCase()
        : "#"; // Fallback for missing names

      if (!acc[firstChar]) {
        acc[firstChar] = [];
      }
      acc[firstChar].push(user);
      return acc;
    }, {});
  };

  const createCall = async () => {
    try {
      let data;
      if (
        callRequest.participantId != null &&
        callRequest.expertiseId == null &&
        callRequest.admin == null
      ) {
        data = await createInternalChatRequest(callRequest);
      } else {
        data = await createSupportChatRequest(callRequest);
        setModalShow(true);
      }
      const existingIndex = Array.isArray(inboxConversations)
        ? inboxConversations.find((item) => item?.id === data?.data?.id)
        : null;
      if (existingIndex) {
        setConversationId(existingIndex?.id);
      } else {
        getCalenderList();
      }
      resetSidebar();
    } catch (error) {
      console.error("Error fetching calendar:", error);
      showAlert({
        title: "Calendar Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  };

  const createCallRequest = (id, isSupportRequest) => {
    if (!isSupportRequest) {
      // setTab(3);
      console.log({
        ...callRequest,
        participantId: id,
        adminId: null,
        expertiseId: null,
      });
      setCallRequest({
        ...callRequest,
        participantId: id,
        adminId: null,
        expertiseId: null,
      });
    } else {
      // setTab(3);
      console.log({
        ...callRequest,
        adminId: showCompany?.id,
        expertiseId: id,
        participantId: null,
      });
      setCallRequest({
        ...callRequest,
        adminId: showCompany?.id,
        expertiseId: id,
        participantId: null,
      });
    }
  };

  const handleStartTimeChange = (e) => {
    const selectedTime = e.target.value;
    setStartTime(selectedTime);

    // Auto-set endTime to 30 mins after startTime
    if (selectedTime) {
      const [hours, minutes] = selectedTime.split(":").map(Number);
      const startDate = new Date();
      startDate.setHours(hours);
      startDate.setMinutes(minutes + 30); // Add 30 minutes

      const endHours = String(startDate.getHours()).padStart(2, "0");
      const endMinutes = String(startDate.getMinutes()).padStart(2, "0");

      setEndTime(`${endHours}:${endMinutes}:00`);
    }
  };

  const changeFilterCriteriaByName = (name, value) => {
    // console.log(name, value);
    // filter[name] = value;
    setSupportList(null);
    // setFilter({ ...filter });
    setFilter((prev) => ({ ...prev, [name]: value }));
  };

  const changeCompanyFilterCriteriaByName = (name, value) => {
    // console.log(name, value);
    // companyExpertiseFilter[name] = value;
    setCompanyExpertise(null);
    setCompanyExpertiseFilter((prev) => ({ ...prev, [name]: value }));

    // setCompanyExpertiseFilter({ ...companyExpertiseFilter });
  };

  const getCompanyDetails = async (company) => {
    try {
      const data = await getExpertiseByAdmin(
        company.id,
        companyExpertiseFilter,
      );
      // console.log("asdasdasd",data?.data)

      console.log("selectedCompany", company);
      // setCompanyExpertise(data);
      setShowCompany(company);
      setTab(2);
      const temp = data?.data?.map((element) => {
        return { ...element, fullName: element.name };
      });
      const grouped = groupByFirstCharacter(temp);
      setCompanyExpertise(grouped);
    } catch (error) {
      console.error("Error fetching support users and company:", error);
      showAlert({
        title: "Calendar Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  };

  const getSupportList = async () => {
    try {
      const data = await getExpertScheduleUsers(filter);

      const temp = data?.data?.map((element) => {
        return {
          ...element,
          fullName:  element?.roleId === 2
              ? element?.companyName
              : element.firstName + " " + element.lastName,
        };
      });
      const grouped = groupByFirstCharacter(temp);
      setSupportList(grouped);
    } catch (error) {
      console.error("Error fetching support users and company:", error);
      showAlert({
        title: "Calendar Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  };

  useEffect(() => {}, [startTime]);

  useEffect(() => {
    getSupportList();
  }, [filter]);

  useEffect(() => {
    if (showCompany) {
      getCompanyDetails(showCompany);
    }
  }, [companyExpertiseFilter]);

  useEffect(() => {
    if (requestDate && startTime && endTime) {
      const startDateTime = new Date(`${requestDate}T${startTime}`);
      const endDateTime = new Date(`${requestDate}T${endTime}`);

      if (startTime && endTime && endTime <= startTime) {
        // alert();
        setEndTime(""); // or optionally auto-advance
        setCallRequest({ ...callRequest, endDate: null });
        return;
      }
      setCallRequest((prev) => ({
        ...prev,
        startTime: startDateTime.toISOString(),
        endTime: endDateTime.toISOString(),
      }));
    }
  }, [requestDate, startTime, endTime]);

  const toggleCollapse = (id) => {
    setProductCollapse((prev) => ({
      ...prev,
      [id]: !prev[id], // toggle only the clicked item
    }));
  };

  const actionButton = callRequest.participantId
    ? "Start Chat"
    : callRequest.expertiseId
      ? "Request Chat"
      : null;

  const handleCloseSidebar = () => {
    resetSidebar();
    setFilter({
      no_of_result: 20,
      page: 1,
      search: "",
      userTypeFilter: 0,
    });
  };

  return (
    <>
      <Offcanvas
        show={newChatSidebar}
        onHide={handleCloseSidebar}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="fs-20 fw-semibold text-gray-700">
            New Chat
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {tab == 2 && (
            <>
              <div className="company-details-collapse">
                <Button
                  variant=""
                  className="company-details-collapse-btn w-100 d-flex align-items-center justify-content-between gap-4"
                  onClick={() =>
                    setCompanyDetailsCollapse(!companyDetailsCollapse)
                  }
                  aria-controls="company-details-collapse"
                  aria-expanded={companyDetailsCollapse}
                >
                  <div className="d-flex align-items-center gap-2">
                    <Image
                      src={
                        showCompany?.profilePic || "/images/company-icon.svg"
                      }
                      width={48}
                      height={48}
                      alt="Company Icon"
                      className="object-fit-cover rounded-circle"
                    />
                    <div className="d-flex flex-column align-items-start gap-1">
                      <p className="fs-16 fw-semibold text-gray-700 mb-0">
                        {showCompany?.companyName}
                      </p>
                      <ul className="d-flex align-items-center gap-2 list-unstyled mb-0">
                        <li
                          className={`fs-14 fw-medium ${
                            getCompanyStatus(showCompany?.companyHours)
                              .status === "Closed"
                              ? "text-red-600"
                              : "text-blue-500"
                          }`}
                        >
                          {getCompanyStatus(showCompany?.companyHours).status}
                        </li>
                        <li className="dot-separator"></li>
                        <li className="fs-14 fw-normal text-gray-500">
                          {getCompanyStatus(showCompany?.companyHours).time}

                          {console.log(
                            "company hours--",
                            getCompanyStatus(showCompany?.companyHours),
                          )}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <Image
                    className="company-details-collapse-btn-arrow"
                    src="/images/caret-down-rounded-gray.svg"
                    width={32}
                    height={32}
                    alt="Company Icon"
                  />
                </Button>
                <Collapse in={companyDetailsCollapse}>
                  <div
                    id="company-details-collapse"
                    className="company-details-collapse-info"
                  >
                    <ul className="d-flex flex-column align-items-start gap-2 list-unstyled mb-0">
                      <li className="fs-14 text-gray-700 d-flex align-items-center gap-2">
                        <Image
                          className="company-details-collapse-btn-arrow"
                          src="/images/envelope-blue.svg"
                          width={18}
                          height={18}
                          alt="Envelope Icon"
                        />
                        <span>{showCompany?.email}</span>
                      </li>
                      {showCompany?.phoneNo && (
                        <li className="fs-14 text-gray-700 d-flex align-items-center gap-2">
                          <Image
                            className="company-details-collapse-btn-arrow"
                            src="/images/phone-call-blue.svg"
                            width={18}
                            height={18}
                            alt="Phone Icon"
                          />
                          <span>
                            +{showCompany?.countryCode} {showCompany?.phoneNo}
                          </span>
                        </li>
                      )}
                      {getAddress(showCompany) && (
                        <li className="fs-14 text-gray-700 d-flex align-items-center gap-2">
                          <Image
                            className="company-details-collapse-btn-arrow"
                            src="/images/map-pin-blue.svg"
                            width={18}
                            height={18}
                            alt="Map Pin Icon"
                          />
                          <span>{getAddress(showCompany)}</span>
                        </li>
                      )}
                    </ul>
                  </div>
                </Collapse>
              </div>

              <input
                id="chat-contact-search"
                type="text"
                className="form-control form-control-search bg-gray-100 border-0 chat-search"
                onChange={(event) =>
                  changeCompanyFilterCriteriaByName(
                    "search",
                    event.target.value,
                  )
                }
                placeholder="Search here..."
              />

              {companyExpertise &&
                Object.keys(companyExpertise)?.map((element, row) => (
                  <>
                    <h3 key={row} className={`fs-16 fw-bold px-2 mb-2 mt-2`}>
                      {element}
                    </h3>
                    {companyExpertise[element].map((subElem, index) => {
                      const isLast =
                        index === companyExpertise[element].length - 1;
                      if (subElem?.children?.length == 0) {
                        return (
                          <div
                            key={subElem?.id}
                            className="chat-contact chat-contact-radio d-flex align-items-center flex-row-reverse justify-content-between gap-3"
                          >
                            <input
                              type="radio"
                              name="recent"
                              id={subElem?.id}
                              checked={subElem?.id === callRequest.expertiseId}
                              value={subElem?.id}
                              onChange={() =>
                                createCallRequest(subElem?.id, true)
                              }
                            />
                            <label
                              htmlFor={subElem?.id}
                              className={`chat-contact-label w-100 d-flex align-items-center justify-content-between ${
                                isLast ? "" : "border-bottom"
                              } border-grey-200 px-2 py-3 gap-3`}
                            >
                              <div className="d-flex align-items-center gap-2">
                                <ImagePreviewLightbox
                                  className="user-avtar user-avtar-48"
                                  src={
                                    subElem?.profilePic ||
                                    "/images/user-circle.svg"
                                  }
                                >
                                  <Image
                                    className="rounded-pill"
                                    src={
                                      subElem?.profilePic ||
                                      subElem?.images?.[0] ||
                                      "/images/user-circle.svg"
                                    }
                                    width={48}
                                    height={48}
                                    alt="User Icon"
                                  />
                                </ImagePreviewLightbox>
                                <p className="fs-16 fw-semibold text-gray-700 mb-0">
                                  {subElem?.fullName}
                                </p>
                              </div>
                            </label>
                          </div>
                        );
                      } else if (subElem?.children?.length > 0) {
                        return (
                          <>
                            <Button
                              variant=""
                              className="product-collapse-btn d-flex align-items-center justify-content-between gap-4"
                              onClick={() =>
                                toggleCollapse(subElem.id || index)
                              }
                              aria-controls={`product-collapse-${subElem.id || index}`}
                              aria-expanded={
                                !!productCollapse[subElem.id || index]
                              }
                            >
                              <div className="d-flex align-items-center gap-2">
                                <div className="product-icon">
                                  <ImagePreviewLightbox
                                    className="user-avtar user-avtar-48"
                                    src={
                                      subElem?.images ||
                                      "/images/product-icon.png"
                                    }
                                  >
                                    <Image
                                      className="rounded-pill"
                                      src={
                                        subElem?.images ||
                                        "/images/product-icon.png"
                                      }
                                      width={48}
                                      height={48}
                                      alt="User Icon"
                                    />
                                  </ImagePreviewLightbox>
                                </div>
                                <p className="fs-16 fw-semibold text-gray-700 mb-0">
                                  {subElem?.fullName}
                                </p>
                              </div>
                              <Image
                                className="product-collapse-btn-arrow"
                                src="/images/caret-up.svg"
                                width={24}
                                height={24}
                                alt="Caret Up Icon"
                              />
                            </Button>
                            <Collapse
                              in={!!productCollapse[subElem.id || index]}
                            >
                              <div
                                id={`product-collapse-${subElem.id || index}`}
                                className="product-list-collapse"
                              >
                                {subElem?.children.map((subProd, subProdId) => (
                                  <div className="chat-contact chat-contact-radio d-flex align-items-center flex-row-reverse justify-content-between gap-3">
                                    <input
                                      type="radio"
                                      name="recent"
                                      id={subProd?.name}
                                      checked={
                                        subProd?.id === callRequest.expertiseId
                                      }
                                      onChange={() =>
                                        createCallRequest(subProd?.id, true)
                                      }
                                    />
                                    <label
                                      htmlFor={subProd?.name}
                                      className="chat-contact-label w-100 d-flex align-items-center justify-content-between p-3 gap-3"
                                    >
                                      <div className="d-flex align-items-center gap-2">
                                        <ImagePreviewLightbox
                                          className="user-avtar user-avtar-36"
                                          src={
                                            subProd?.images ||
                                            "/images/product-icon.png"
                                          }
                                        >
                                          <Image
                                            className="rounded-pill"
                                            src={
                                              subProd?.images ||
                                              "/images/product-icon.png"
                                            }
                                            width={36}
                                            height={36}
                                            alt="User Icon"
                                          />
                                        </ImagePreviewLightbox>
                                        <p className="fs-16 fw-semibold text-gray-700 mb-0">
                                          {subProd?.name}
                                        </p>
                                      </div>
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </Collapse>
                          </>
                        );
                      }
                    })}
                  </>
                ))}
            </>
          )}

          {tab == 1 && (
            <div className="chat-filters p-0">
              <input
                id="chat-contact-search1"
                type="text"
                onChange={(event) =>
                  changeFilterCriteriaByName("search", event.target.value)
                }
                className="form-control form-control-search bg-gray-100 border-0 chat-search"
                placeholder="Search here..."
              />
              <div className="chat-filter-tabs">
                <button
                  type="button"
                  onClick={() =>
                    changeFilterCriteriaByName("userTypeFilter", "0")
                  }
                  className={`chat-filter ${
                    filter.userTypeFilter == 0 ? "active" : ""
                  }`}
                >
                  All
                </button>
                <button
                  type="button"
                  className={`chat-filter ${
                    filter.userTypeFilter == 1 ? "active" : ""
                  }`}
                  onClick={() =>
                    changeFilterCriteriaByName("userTypeFilter", "1")
                  }
                >
                  Internal
                </button>
                <button
                  type="button"
                  className={`chat-filter ${
                    filter.userTypeFilter == 2 ? "active" : ""
                  }`}
                  onClick={() =>
                    changeFilterCriteriaByName("userTypeFilter", "2")
                  }
                >
                  External
                </button>
              </div>
            </div>
          )}

          {tab == 1 && (
            <div className="chat-contact-list mt-3">
              <div className="mb-4">
                {supportList &&
                  Object.keys(supportList)?.map((element, row) => (
                    <>
                      <h3
                        key={row}
                        className={`fs-16 fw-bold px-2 ${
                          row == 0 ? "mb-2" : "mb-2 mt-2"
                        }`}
                      >
                        {element}
                      </h3>
                      {supportList[element].map((subElem, index) => {
                        const isLast =
                          index === supportList[element].length - 1;
                        if (subElem?.roleId == 3) {
                          return (
                            <div
                              key={subElem?.id}
                              className="chat-contact chat-contact-radio d-flex align-items-center flex-row-reverse justify-content-between gap-3"
                            >
                              <input
                                type="radio"
                                name="recent"
                                id={subElem?.id}
                                checked={
                                  subElem?.id === callRequest.participantId
                                }
                                onChange={() =>
                                  createCallRequest(subElem?.id, false)
                                }
                              />
                              <label
                                htmlFor={subElem?.id}
                                className={`chat-contact-label w-100 d-flex align-items-center justify-content-between ${
                                  isLast ? "" : "border-bottom"
                                } border-grey-200 px-2 py-3 gap-3`}
                              >
                                <div className="d-flex align-items-center gap-2">
                                  <ImagePreviewLightbox
                                    className="user-avtar user-avtar-48"
                                    src={
                                      subElem?.profilePic ||
                                      "/images/user-circle.svg"
                                    }
                                  >
                                    <Image
                                      className="rounded-pill"
                                      src={
                                        subElem?.profilePic ||
                                        "/images/user-circle.svg"
                                      }
                                      width={48}
                                      height={48}
                                      alt="User Icon"
                                    />
                                  </ImagePreviewLightbox>
                                  <p className="fs-16 fw-semibold text-gray-700 mb-0">
                                    {subElem?.fullName}
                                  </p>
                                </div>
                              </label>
                            </div>
                          );
                        } else if (subElem?.roleId == 5) {
                          return (
                            <div
                              key={subElem?.id}
                              className="chat-contact chat-contact-radio d-flex align-items-center flex-row-reverse justify-content-between gap-3"
                            >
                              <input
                                type="radio"
                                name="recent"
                                id={subElem?.id}
                                checked={
                                  subElem?.id === callRequest.participantId
                                }
                                onChange={() =>
                                  createCallRequest(subElem?.id, false)
                                }
                              />
                              <label
                                htmlFor={subElem?.id}
                                className={`chat-contact-label w-100 d-flex align-items-center justify-content-between ${
                                  isLast ? "" : "border-bottom"
                                } border-grey-200 px-2 py-3 gap-3`}
                              >
                                <div className="d-flex align-items-center gap-2">
                                  <ImagePreviewLightbox
                                    className="user-avtar user-avtar-48"
                                    src={
                                      subElem?.profilePic ||
                                      "/images/user-circle.svg"
                                    }
                                  >
                                    <Image
                                      className="rounded-pill"
                                      src={
                                        subElem?.profilePic ||
                                        "/images/user-circle.svg"
                                      }
                                      width={48}
                                      height={48}
                                      alt="User Icon"
                                    />
                                  </ImagePreviewLightbox>
                                  <p className="fs-16 fw-semibold text-gray-700 mb-0">
                                    {subElem?.fullName}
                                  </p>
                                </div>
                              </label>
                            </div>
                          );
                        } else if (subElem?.roleId == 2) {
                          // const timeData = getCompanyStatus(subElem?.companyHours)
                          return (
                            <div
                              key={subElem?.id}
                              className="chat-contact d-flex align-items-center justify-content-between px-2 py-3 gap-3"
                              onClick={() => getCompanyDetails(subElem)}
                            >
                              <div className="d-flex align-items-center gap-2">
                                <ImagePreviewLightbox
                                  className="user-avtar user-avtar-48"
                                  src={
                                    subElem?.profilePic ||
                                    "/images/company-icon.png"
                                  }
                                >
                                  <Image
                                    className="rounded-pill"
                                    src={
                                      subElem?.profilePic ||
                                      "/images/company-icon.png"
                                    }
                                    width={48}
                                    height={48}
                                    alt="User Icon"
                                  />
                                </ImagePreviewLightbox>
                                <div className="d-flex flex-column align-items-start gap-1">
                                  <p className="fs-16 fw-semibold text-gray-700 mb-0">
                                    {subElem?.companyName}
                                  </p>
                                  <ul className="d-flex align-items-center gap-2 list-unstyled mb-0">
                                    {(() => {
                                      const timeData = getCompanyStatus(
                                        subElem?.companyHours,
                                      );
                                      return (
                                        <>
                                          <li
                                            className={`fs-14 fw-medium ${
                                              timeData.status === "Closed"
                                                ? "text-red-600"
                                                : "text-blue-600"
                                            }`}
                                          >
                                            {timeData.status}
                                          </li>
                                          <li className="dot-separator"></li>
                                          <li className="fs-14 fw-normal text-gray-500">
                                            {timeData.time}
                                          </li>
                                        </>
                                      );
                                    })()}
                                  </ul>
                                </div>
                              </div>
                              <Image
                                className="opacity-75"
                                src="/images/caret-right.svg"
                                width={20}
                                height={20}
                                alt="Arrow Right"
                              />
                            </div>
                          );
                        }
                      })}
                    </>
                  ))}
              </div>
            </div>
          )}

          {tab == 3 && (
            <>
              <Form.Group
                controlId="request-date"
                className="position-relative mb-3"
              >
                <Form.Label>Request Date</Form.Label>
                <div className="form-control-date">
                  <Form.Control
                    type="date"
                    name="request-date"
                    value={requestDate}
                    onChange={(e) => setRequestDate(e.target.value)}
                  />
                </div>
              </Form.Group>

              <Form.Group
                controlId="start-time"
                className="position-relative mb-3"
              >
                <Form.Label>Start Time</Form.Label>
                <Form.Control
                  type="time"
                  name="start-time"
                  className="form-control-time"
                  value={startTime}
                  onChange={handleStartTimeChange}
                  // onChange={(e) => setStartTime(e.target.value)}
                />
              </Form.Group>

              <Form.Group
                controlId="end-time"
                className="position-relative mb-3"
              >
                <Form.Label>End Time</Form.Label>
                <Form.Control
                  type="time"
                  name="end-time"
                  className="form-control-time"
                  value={endTime}
                  min={startTime}
                  onChange={(e) => setEndTime(e.target.value)}
                />
              </Form.Group>
            </>
          )}
        </Offcanvas.Body>
        <div className="offcanvas-footer">
          {(tab == 1 || tab == 2) && (
            <Button
              variant="primary"
              className="btn-md"
              disabled={
                (tab == 1 && callRequest.participantId == null) ||
                (tab == 2 && (!callRequest.adminId || !callRequest.expertiseId))
              }
              hidden={
                (tab == 1 && callRequest.participantId !== null) || tab == 2
              }
              //   onClick={() => {
              //     if (tab == 1 && callRequest.userId != null) {
              //       setTab(3);
              //     } else if (tab == 2 && callRequest.adminId && callRequest.expertiseId) {
              //       setTab(3);
              //     }
              //   }}
            >
              Next
            </Button>
          )}

          {tab == 2 && (
            <Button
              variant="outline-secondary"
              className="btn-md"
              onClick={() => {
                setTab((prev) => prev - 1);
              }}
            >
              Previous
            </Button>
          )}

          {(tab === 1 || tab === 2) && actionButton && (
            <Button
              variant="primary"
              className="btn-md"
              onClick={() => createCall()}
              disabled={
                (tab === 1 && !callRequest.participantId) ||
                (tab === 2 &&
                  (!callRequest.adminId || !callRequest.expertiseId))
              }
            >
              {actionButton}
            </Button>
          )}

          {tab != 2 && (
            <Button
              variant="outline-secondary"
              className="btn-md"
              onClick={() => {
                resetSidebar();
              }}
            >
              Cancel
            </Button>
          )}
        </div>
      </Offcanvas>

      <Modal
        className="info-modal"
        show={modalShow}
        onHide={() => setModalShow(false)}
        centered
      >
        <Modal.Body>
          <div className="text-center">
            <Image src="/images/check-badge-green.svg" alt="Check Icon" />
            <h2 className="fs-2 fw-semibold text-gray-700 mt-5 mb-2">
              Chat Request Successful!
            </h2>
            <p className="fs-5 text-gray-500 fw-normal mb-0">
              Check your calendar for updates. Notifications will also be sent
              via push and email.
            </p>
            <Button
              className="btn bntn-primary w-100 mt-5"
              onClick={() => setModalShow(false)}
            >
              That's Great!
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default StartNewConversation;
